import { useState, useLayoutEffect } from "react";

import { LoadingSpinner } from "@newsela/angelou";

import DirectoryTabs from "@/directory/DirectoryTabs";
import SettingsBasePage from "@/settings/SettingsBasePage";
import useTeacherGet from "@/teacher/hooks/useTeacherGet";
import useUser from "@/users/useUser";
import SchoolTable from "./SchoolTable";
import ProfileDetails from "./ProfileDetails";

const SETTINGS_BASE_PAGE_PROPS = {
  breadcrumbsLinks: {
    href: "/account/settings/",
    contents: "Profile",
  },
};

const AccountSettingsPage = () => {
  const initialUser = useUser();
  const initialTeacher = useTeacherGet(initialUser.data.teacher?.id);
  const [{ data: user }, setUser] = useState(initialUser);
  const [{ data: teacher, loading: isLoadingTeacher }, setTeacher] =
    useState(initialTeacher);
  const [tab, setTab] = useState(0);
  const isMultipleSchoolView =
    !user.roles.includes("student") && user.schools.length > 1;

  useLayoutEffect(() => {
    setTeacher(initialTeacher);
  }, [initialTeacher]);

  const tabs = [
    {
      id: 0,
      title: "Details",
      content: (
        <ProfileDetails
          user={user}
          teacher={teacher}
          onChangeUser={(data) => setUser({ data })}
          onChangeTeacher={(data) => setTeacher({ data })}
        />
      ),
    },
    {
      id: 1,
      title: "Schools",
      content: <SchoolTable user={user} />,
      hide: !isMultipleSchoolView,
    },
  ];

  return (
    <SettingsBasePage
      {...SETTINGS_BASE_PAGE_PROPS}
      title={`${user.first_name} ${user.last_name}`}
      showHeaderSeparator={!isMultipleSchoolView}
    >
      {isLoadingTeacher ? (
        <LoadingSpinner />
      ) : (
        <DirectoryTabs
          defaultActiveTab={tab}
          items={tabs}
          onChange={setTab}
          alwaysRender
        />
      )}
    </SettingsBasePage>
  );
};

export default AccountSettingsPage;
